import { render, staticRenderFns } from "./img-card.vue?vue&type=template&id=0ced825c&scoped=true&"
import script from "./img-card.vue?vue&type=script&lang=js&"
export * from "./img-card.vue?vue&type=script&lang=js&"
import style0 from "./img-card.vue?vue&type=style&index=0&id=0ced825c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ced825c",
  null
  
)

export default component.exports